import { render } from "./EditGoalModal.vue?vue&type=template&id=4a32471f&scoped=true"
import script from "./EditGoalModal.vue?vue&type=script&lang=js"
export * from "./EditGoalModal.vue?vue&type=script&lang=js"

import "./EditGoalModal.vue?vue&type=style&index=0&id=4a32471f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a32471f"]])

export default __exports__